import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class SelectHelpers<T> {

  constructor() {}

    updateSelections(checked: boolean, selectedEntity: T, entityList: T[]): T[] {
        if(checked) {
            entityList.push(selectedEntity);
          } else {
            entityList = entityList.filter(entity => !_.isEqual(entity,selectedEntity));
          }
        return entityList;
    }

    isSelected(entity: T | null, selectedEntityList: T[] | null): boolean {
      if(selectedEntityList && selectedEntityList.length > 0) {
        return selectedEntityList.filter(e => _.isEqual(e, entity)).length >= 1;
      } else {
        return false;
      }
    }

    allSelected(entityList: T[] | null, selectionList: T[] | null): boolean {
      const internalEntityList = entityList? entityList : [];
      const internalSelectionList = selectionList ? selectionList: [];

      const matches = this.findSelectionMatches(internalEntityList, internalSelectionList);

      return internalEntityList.length > 0 ? matches.length === internalEntityList.length : false;
    }

  private findSelectionMatches(entityList: T[], selectionList: T[]) {
    return entityList.filter(entity => selectionList.filter(selectedEntity => _.isEqual(selectedEntity, entity)).length >= 1);
  }

    handleToggleMaster(entityList: T[], selectedEntityList: T[]): T[] {
      if (this.allSelected(entityList, selectedEntityList)) {
        selectedEntityList = this.clearPageSelections(entityList, selectedEntityList);
      } else {
        const notSelected = entityList
          .filter(entity => selectedEntityList.filter(selectedEntity => _.isEqual(selectedEntity, entity)).length < 1);
        selectedEntityList.push(...notSelected);
      }

      return selectedEntityList;
    }

    clearPageSelections(entityList: T[], selectedEntityList: T[]) {
      selectedEntityList = selectedEntityList.filter(selectedEntity => {
        const present = entityList.find(entity => _.isEqual(entity, selectedEntity));
        return present ? false : true;
      });

      return selectedEntityList;
    }

    clearAll(selectedEntityList: T[]) {
      selectedEntityList = [];
      return selectedEntityList;
    }
}
